import React, { useState } from "react";
import { ChevronDown } from "lucide-react";

// ✅ use icons from your StatsIcons file
import {
  TotalProductsIcon,
  TotalBinsIcon,
  InwardIcon,
  NearExpiryIcon,
} from "../assets/states/StatsIcons";

const MOCK_INVENTORY_CARDS = [
  {
    label: "Total Products",
    value: "20",
    sub: "SKUs",
    Icon: TotalProductsIcon,
    bg: "#01C36F",
    stroke: true,
  },
  {
    label: "Total Batches",
    value: "20",
    sub: "Active",
    Icon: TotalBinsIcon,
    bg: "#4F46E5",
    stroke: true,
  },
  {
    label: "Total Quantity",
    value: "50",
    sub: "Units",
    Icon: InwardIcon,
    bg: "#2CAEFF",
    stroke: false,
  },
  {
    label: "Low Stock Items",
    value: "50",
    sub: "Below reorder",
    Icon: NearExpiryIcon,
    bg: "#EE7C19",
    stroke: false,
  },
];

export function InventoryManagement() {
  const [panelOpen, setPanelOpen] = useState(true);

  return (
    <div className="page-container">
      {/* ✅ ONE BIG CAPSULE (Header + Cards inside) */}
      <section className="rounded-[28px] border border-gray-100 bg-white px-6 py-5 shadow-sm">
        {/* Title row */}
        <div className="flex items-center justify-between">
          <h1 className="text-sm font-medium text-gray-900">
            Inventory Management
          </h1>

          <button
            type="button"
            onClick={() => setPanelOpen((o) => !o)}
            className="grid h-9 w-9 place-items-center rounded-full text-gray-600 transition hover:bg-gray-100"
            aria-expanded={panelOpen}
          >
            <ChevronDown
              className={`h-5 w-5 transition-transform duration-200 ${
                panelOpen ? "" : "-rotate-180"
              }`}
              aria-hidden
            />
          </button>
        </div>

        {/* Cards row */}
        <div
          className={`transition-all duration-200 ${
            panelOpen
              ? "mt-6 max-h-[999px] opacity-100"
              : "max-h-0 overflow-hidden opacity-0"
          }`}
        >
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
            {MOCK_INVENTORY_CARDS.map((card) => {
              const Icon = card.Icon;

              return (
                <div
                  key={card.label}
                  className="flex items-center gap-4 rounded-2xl border border-gray-100 bg-white px-5 py-4 shadow-sm"
                >
                  {/* ✅ icon bg exact shape + size */}
                  <div
                    className="flex items-center justify-center"
                    style={{
                      width: 63,
                      height: 63,
                      borderTopLeftRadius: 24,
                      borderTopRightRadius: 8,
                      borderBottomRightRadius: 24,
                      borderBottomLeftRadius: 8,
                      background: card.bg,
                      flexShrink: 0,
                    }}
                  >
                    {card.stroke ? (
                      <Icon size={24} color="#FFFFFF" />
                    ) : (
                      <Icon size={24} />
                    )}
                  </div>

                  {/* ✅ text same like screenshot */}
                  <div className="min-w-0">
                    <p className="text-sm font-medium text-gray-400">
                      {card.label}
                    </p>

                    <div className="mt-1 flex items-baseline gap-2">
                      <p className="text-xl font-semibold text-gray-900">
                        {card.value}
                      </p>
                      {card.sub && (
                        <p className="text-xs text-gray-400">({card.sub})</p>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
}
